/* tslint:disable */
/* eslint-disable */
/**
 * Litiverse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProsecutionPublic } from './ProsecutionPublic';
import {
    ProsecutionPublicFromJSON,
    ProsecutionPublicFromJSONTyped,
    ProsecutionPublicToJSON,
    ProsecutionPublicToJSONTyped,
} from './ProsecutionPublic';

/**
 * Public schema for SEC individuals with limited data for non-authenticated users.
 * @export
 * @interface SECIndividualPublic
 */
export interface SECIndividualPublic {
    /**
     * 
     * @type {number}
     * @memberof SECIndividualPublic
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof SECIndividualPublic
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof SECIndividualPublic
     */
    specialization?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SECIndividualPublic
     */
    totalCases?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SECIndividualPublic
     */
    totalSettlements?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SECIndividualPublic
     */
    currentOffice?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SECIndividualPublic
     */
    yearsActive?: number | null;
    /**
     * Recent prosecutions (limited data)
     * @type {Array<ProsecutionPublic>}
     * @memberof SECIndividualPublic
     */
    recentProsecutions?: Array<ProsecutionPublic>;
}

/**
 * Check if a given object implements the SECIndividualPublic interface.
 */
export function instanceOfSECIndividualPublic(value: object): value is SECIndividualPublic {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function SECIndividualPublicFromJSON(json: any): SECIndividualPublic {
    return SECIndividualPublicFromJSONTyped(json, false);
}

export function SECIndividualPublicFromJSONTyped(json: any, ignoreDiscriminator: boolean): SECIndividualPublic {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'specialization': json['specialization'] == null ? undefined : json['specialization'],
        'totalCases': json['total_cases'] == null ? undefined : json['total_cases'],
        'totalSettlements': json['total_settlements'] == null ? undefined : json['total_settlements'],
        'currentOffice': json['current_office'] == null ? undefined : json['current_office'],
        'yearsActive': json['years_active'] == null ? undefined : json['years_active'],
        'recentProsecutions': json['recent_prosecutions'] == null ? undefined : ((json['recent_prosecutions'] as Array<any>).map(ProsecutionPublicFromJSON)),
    };
}

export function SECIndividualPublicToJSON(json: any): SECIndividualPublic {
    return SECIndividualPublicToJSONTyped(json, false);
}

export function SECIndividualPublicToJSONTyped(value?: SECIndividualPublic | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'specialization': value['specialization'],
        'total_cases': value['totalCases'],
        'total_settlements': value['totalSettlements'],
        'current_office': value['currentOffice'],
        'years_active': value['yearsActive'],
        'recent_prosecutions': value['recentProsecutions'] == null ? undefined : ((value['recentProsecutions'] as Array<any>).map(ProsecutionPublicToJSON)),
    };
}

